<template>
    <div>
        <v-dialog :value="loading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Loading Data
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog lazy v-model="message_dialog">
            <v-card>
                <v-card-title primary-title>
                    Enter message to send
                </v-card-title>
                <v-card-text>

                    <v-text-field type="textarea" label="Message" v-model="message"
                                  :rules="[val => !!val || 'Required Field']"/>

                    <v-btn color="primary" @click="sendMessage">
                        Send Message
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-container :fluid="true" v-if="captain" style="padding:0">
            <v-layout column>
                <v-flex xs12 class="item">
                    <v-card color="secondary darken-1" class="white--text" style="padding: 10px 0">
                        <v-layout align-center>
                            <v-flex md2 xs12>
                                <v-img :src="api.GET_IMAGE(captain.profile_image)" height="125px" contain></v-img>
                            </v-flex>
                            <v-flex md6 xs12>
                                <v-card-title primary-title>
                                    <div>
                                        <div class="headline">{{captain.first_name + ' ' + captain.last_name}}</div>
                                        <div>{{captain.email}}</div>
                                        <div>{{moment(captain.created_at).format('DD MMM YYYY')}}</div>
                                        <div>
                                            <v-rating
                                                    style="display: inline"
                                                    v-model="captain.average_rating"
                                                    background-color="yellow accent-4"
                                                    color="yellow accent-4" readonly
                                                    dense half-increments hover small
                                            ></v-rating>
                                            <span v-if="captain.total_ratings > 0"
                                                  class="grey--text text--lighten-2 caption mr-2">
                                                ({{round(captain.average_rating, 1)}} from {{captain.total_ratings}} rate)
                                            </span>
                                            <span v-else class="grey--text text--lighten-2 caption mr-2">
                                                no ratings
                                            </span>
                                        </div>
                                    </div>
                                </v-card-title>
                            </v-flex>
                            <v-flex md4 xs12>
                                <v-layout row wrap>
                                    <v-flex xs12 class="subheading font-weight-bold white--text">
                                        Captain Avg Speed : {{captain.captain_avg_speed &&
                                        captain.captain_avg_speed.toFixed(2)}} KM/H
                                        <br/>
                                        All Avg Speed : {{captain.global_avg_speed &&
                                        captain.global_avg_speed.toFixed(2)}} KM/H
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-btn color="white" flat @click="resetPicture">
                                            Reset Picture
                                        </v-btn>
                                        <v-btn @click="message_dialog = true">Send Message</v-btn>
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12>
                    <v-tabs v-model="tab" color="secondary" grow>
                        <v-tabs-slider color="white"></v-tabs-slider>
                        <v-tab v-for="item in items" :key="item" :disabled="loading">
                            {{ item }}
                        </v-tab>
                        <v-tab-item lazy>
                            <info provider="Captain" :data="captain">
                                <v-form ref="form">
                                    <v-layout row>
                                        <v-flex xs4>
                                            <v-subheader>Photo</v-subheader>
                                        </v-flex>
                                        <v-flex xs8>
                                            <img :src="imageUrl" height="150" v-if="imageUrl"/>
                                            <v-text-field label="Select Image"
                                                          @click='$refs.image.click()'
                                                          v-model='imageName'
                                                          append-icon='attach_file'
                                                          readonly
                                            ></v-text-field>
                                            <input
                                                    type="file"
                                                    style="display: none"
                                                    ref="image"
                                                    accept="image/*"
                                                    @change="onFilePicked"
                                            >
                                        </v-flex>
                                    </v-layout>
                                    <v-btn @click="save" color="primary">Save</v-btn>
                                </v-form>
                                <v-form v-if="captain.approved_at && !captain.no_conviction && hasPermission('APPROVE_CAPTAINS')"
                                        ref="form2">
                                    <v-layout row>
                                        <v-flex xs4>
                                            <v-subheader>No Conviction</v-subheader>
                                        </v-flex>
                                        <v-flex xs8>
                                            <img :src="noConvictionUrl" height="150" v-if="noConvictionUrl"/>
                                            <v-text-field label="Select Image"
                                                          @click='$refs.no_conviction.click()'
                                                          v-model='noConvictionName'
                                                          append-icon='attach_file'
                                                          readonly
                                            ></v-text-field>
                                            <input
                                                    type="file"
                                                    style="display: none"
                                                    ref="no_conviction"
                                                    accept="image/*"
                                                    @change="onNoConvictionPicked"
                                            >
                                        </v-flex>
                                    </v-layout>
                                    <v-btn @click="saveNoConviction" color="primary">Save</v-btn>
                                </v-form>
                            </info>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <rating-log :captain_id="captain.id"/>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <check-log-component :captain="captain"/>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <v-card flat>
                                <contracts :captain_id="captain.id"></contracts>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <v-card flat>
                                <cars :captain_id="captain.id"></cars>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <v-card flat>
                                <schedule v-if="captain && captain.id" :captain-id="captain.id"/>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <rides :captain_id="$route.params.id"></rides>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <transactions provider="captains" :id="$route.params.id"/>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <notes provider="captains" :id="$route.params.id"/>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <statistics :id="$route.params.id"></statistics>
                        </v-tab-item>
                        <v-tab-item v-if="hasPermission('VIEW_CAPTAIN_TIMELINE')" lazy>
                            <captain-timeline :captain-id="$route.params.id"/>
                        </v-tab-item>

                        <v-tab-item v-if="hasPermission('VIEW_CAPTAIN_BLACKLIST_LOG')" lazy>
                            <data-table :url="api.ACTIONS.CAPTAIN_BLACKLIST_HISTORY($route.params.id)"
                                        :enable-edit="false"
                                        :enable-add="false"
                                        :enable-delete="false"
                                        disable-search/>
                        </v-tab-item>
                    </v-tabs>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import moment from "moment";
    import notes from '@/components/profile/notes';
    import info from '@/components/profile/info';
    import rides from '@/components/profile/captain/Rides';
    import CheckLogComponent from "@/components/wasilni/CheckLogComponent";
    import Contracts from '@/components/confirmation_captain_components/Contracts';
    import Transactions from "@/components/accounting/Transactions";
    import Schedule from "@/components/profile/captain/Schedule";
    import Cars from "@/views/captains/Cars";
    import Statistics from "@/components/profile/captain/Statistics";
    import DataTable from "@/components/wasilni/DataTable";
    import CaptainTimeline from "@/components/profile/captain/Timeline";
    import RatingLog from "@/components/profile/captain/RatingLog";

    export default {
        name: "passenger_profile",
        title: 'Captain Profile',
        components: {
            RatingLog,
            CaptainTimeline,
            DataTable,
            Statistics,
            Cars,
            Schedule,
            Contracts,
            CheckLogComponent,
            notes,
            info,
            rides,
            Transactions
        },
        data() {
            return {
                tab: 0,
                loading: true,
                captain: {},
                rating: 4.3,
                imageName: '',
                imageUrl: '',
                imageFile: '',
                message_dialog: false,
                message: null,
                noConvictionUrl: '',
                noConvictionName: '',
                noConvictionFile: '',
            };
        },
        mounted() {
            this.axios.get(`captain/${this.$route.params.id}`)
                .then(({data}) => {
                        data.data.average_rating = this.round(data.data.average_rating, 1);
                        this.captain = data.data;
                        this.loading = false;
                    }
                )
                .catch(err => {
                    if (err.response.status === 404) {
                        this.$router.push('/captains');
                        window.getApp.$emit('SHOW_TOAST', 'captain not found', 'red');
                    } else {
                        let message = '';
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = 'failed to get captain, please open inspect tool and take a screen shot';
                        }
                        window.getApp.$emit('SHOW_TOAST', message, 'red');
                    }
                });
        },
        methods: {
            sendMessage() {
                this.loading = true;
                this.axios.put('broadcast', {
                    ids: [this.captain.id],
                    broadcast: ['Whatsapp'],
                    message: this.message,
                    provider: 'captains'
                }).then(
                    () => {
                        this.message_dialog = false;
                        window.getApp.$emit("SHOW_TOAST", "Tried");
                    }
                )
                    .finally(
                        () => this.loading = false
                    )
            },
            round(val, point_cnt = 2) {
                return Math.round((val) * Math.pow(10, point_cnt)) / Math.pow(10, point_cnt)
            },
            onFilePicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.imageName = files[0].name;
                    if (this.imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result;
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.imageName = '';
                    this.imageFile = '';
                    this.imageUrl = '';
                }
            },
            onNoConvictionPicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.noConvictionName = files[0].name;
                    if (this.noConvictionName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.noConvictionUrl = fr.result;
                        this.noConvictionFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.noConvictionName = '';
                    this.noConvictionUrl = '';
                    this.noConvictionFile = '';
                }
            },
            resetPicture() {
                this.loading = true;
                this.axios.put(this.api.ACTIONS.CAPTAINS + '/' + this.captain.id, {
                    profile_image: null
                }).then(
                    ({data}) => {
                        this.imageName = '';
                        this.imageFile = '';
                        this.imageUrl = '';
                        this.captain = data.data
                    }
                ).finally(
                    () => this.loading = false
                )
            },
            save() {
                if (this.$refs.form.validate()) {
                    const updatedData = [];
                    if (this.imageFile)
                        updatedData.push({["captain[profile_image]"]: this.imageFile});
                    if (updatedData.length > 0) {
                        this.loading = true;
                        const formData = new FormData();
                        formData.append("_method", "PUT");
                        for (const field of updatedData) {
                            const key = Object.keys(field)[0];
                            formData.append(key, field[key]);
                        }
                        this.axios.post(this.api.ACTIONS.CAPTAINS + '/' + this.captain.id, formData)
                            .then(({data}) => {
                                this.imageName = '';
                                this.imageFile = '';
                                this.imageUrl = '';
                                this.captain = data.data;
                                this.loading = false;
                                window.getApp.$emit('SHOW_TOAST', 'Saved');
                            });
                    }

                } else {
                    window.getApp.$emit("SHOW_TOAST", "Please check all fields", "red");
                }
            },
            saveNoConviction() {
                if (this.$refs.form2.validate()) {
                    const updatedData = [];
                    if (this.noConvictionFile)
                        updatedData.push({["captain[no_conviction]"]: this.noConvictionFile});
                    if (updatedData.length > 0) {
                        this.loading = true;
                        const formData = new FormData();
                        formData.append("_method", "PUT");
                        for (const field of updatedData) {
                            const key = Object.keys(field)[0];
                            formData.append(key, field[key]);
                        }
                        this.axios.post(this.api.ACTIONS.CAPTAINS + '/' + this.captain.id, formData)
                            .then(({data}) => {
                                this.noConvictionName = '';
                                this.noConvictionFile = '';
                                this.noConvictionUrl = '';
                                this.captain = data.data;
                                this.loading = false;
                                window.getApp.$emit('SHOW_TOAST', 'Saved');
                            });
                    }

                } else {
                    window.getApp.$emit("SHOW_TOAST", "Please check all fields", "red");
                }
            },
        },
        computed: {
            today() {
                return moment().format("YYYY-MM-DD");
            },
            items() {
                let data = ['info', 'Rate History', 'Check Log', 'contracts', 'cars', 'Schedule', 'rides', 'accounting', 'notes', 'stats'];


                if (this.hasPermission("VIEW_CAPTAIN_TIMELINE"))
                    data.push("Timeline");
                if (this.hasPermission("VIEW_CAPTAIN_BLACKLIST_LOG"))
                    data.push("Blacklist Log");
                return data;
            }
        }
    }

</script>

<style scoped>

</style>
